import { Tab, Tabs } from "@mui/material";
import { useMemo, useState } from "react";
import { TabPanel } from "../App/Components/TabGroup/TabGroup";
import { FormCapturesTimeframe } from "./Components/Analytics/FormCapturesTimeframe";
import CandidatesCaptured from "./Components/CandidatesCaptured/CandidatesCaptured";
import { CampaignProfileState } from "./State/CampaignProfileState";
import { useFeaturePermission } from "../App/State/Hooks/abacHooks";
import { AppFeatureLookup } from "../App/Constants/AbacConstants";

const tabs = {
  candidates: "Candidates",
  analytics: "Analytics",
};

function getFormTablePanelProps(index: number) {
  return {
    id: `form-table-tab-${index}`,
    "aria-controls": `form-table-tabpanel-${index}`,
  };
}

export default function FormTableTabs({
  state,
  campaignId,
  formId,
}: {
  state: CampaignProfileState;
  campaignId: string;
  formId: string;
}) {
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const accessCandidatesAddedByCampaignReport = useFeaturePermission(
    AppFeatureLookup.CampaignCandidatesAddedByCampaignReport,
  );

  const displayTabs = useMemo(
    () =>
      accessCandidatesAddedByCampaignReport
        ? tabs
        : Object.fromEntries(Object.entries(tabs).filter(([key, value]) => key !== "analytics")),
    [accessCandidatesAddedByCampaignReport],
  );

  const getTabs = () => {
    return Object.entries(displayTabs).map(([key, label], i) => (
      <Tab data-test={`form-${key}-tab`} label={label} {...getFormTablePanelProps(i)} />
    ));
  };
  const getTabPanels = () => {
    return Object.entries(displayTabs).map(([key, label], i) => (
      <TabPanel data-test={`form-${key}-tab-panel`} value={tabValue} index={i}>
        {key === "candidates" && (
          <CandidatesCaptured
            campaignId={campaignId}
            formId={formId}
            formVersion={state.getters.lastUpdatedDate}
          />
        )}
        {key === "analytics" && <FormCapturesTimeframe state={state} />}
      </TabPanel>
    ));
  };

  return (
    <>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        aria-label="Form Table Tabs"
        sx={{ width: "auto", borderBottom: 1, borderColor: "divider", mb: 3 }}
      >
        {getTabs()}
      </Tabs>
      {getTabPanels()}
    </>
  );
}
